function SignupPasswordValidator(password) {
  const hasDisallowedChars = /['";\\%*]|--|\/\*|\*\//.test(password);

  return {
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[!@#$%^&*(),.?":{}|<>_\-+=~`\[\]\\]/.test(password),
    hasMinLength: password.length >= 12,
    isSafe: !hasDisallowedChars, // ✅ Return false if dangerous chars exist
  };
}

export default SignupPasswordValidator;
